module.exports = __webpack_public_path__ + "85926f57b9b2f6ca3d4095ecb36c807d.svg";